angular.module('property-deal')
    .controller('PropertyDealAgreementsEditController', function ($http, toastr, $scope, $rootScope, $uibModalInstance, data, PropertyDeal, Project, PropertyService, PropertyDealService, LeadService) {
        this.PropertyService = PropertyService;
        this.PropertyDealService = PropertyDealService;
        this.LeadService = LeadService;
        this.item = angular.copy(data)
        this.form = {
            id: data.id,
            leadId: data.leadId,
            status: data.status,
            prebooking: data.prebooking,
            booked: data.booked,
            contract: data.contract,
            transfer: data.transfer,
            finalContract: data.finalContract,
            finalContractConditional: data.finalContractConditional,
            cancellation: data.cancellation
        }

        this.$onInit = () => {
            this.contractTypes = ['DEVELOPMENT', 'PRELIMINARY_SALE', 'CONDITIONAL_SALE'];
            this.finalContractTypes = ['CONDITIONAL_SALE_BEFORE_OWNERSHIP_TRANSFER', 'OWNERSHIP_TRANSFER'];
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.save = () => {
            return PropertyDeal.agreementsUpdate(this.form).$promise.then(result => {
                $rootScope.$broadcast('property-deal.updated', result);
                toastr.success("Zapisano");
                $uibModalInstance.close(result);
            })
        };

        this.deleteAgreement = (agreement) => {
            PropertyDeal.agreementDelete({id: this.form.id, agreement: agreement}).$promise.then(() => {
                this.form[agreement] = null
                $rootScope.$broadcast('property-deal.updated');
                toastr.success("Zapisano");
            })
        }
    })
